// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2490":"css/app.7061","7526":"css/admin-app.7061"}[chunkId] + ".css";
};